import React, { useEffect } from "react";

const AiVoice = () => {
  useEffect(() => {
    // Chỉ nhúng script nếu chưa có
    if (!document.getElementById("elevenlabs-convai-script")) {
      const script = document.createElement("script");
      script.src = "https://unpkg.com/@elevenlabs/convai-widget-embed";
      script.async = true;
      script.type = "text/javascript";
      script.id = "elevenlabs-convai-script";
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div>
      <elevenlabs-convai agent-id="agent_01k08qr1fwen781vzc44w5aarr"></elevenlabs-convai>
    </div>
  );
};

export default AiVoice;